import ServiceRequestAPI from './service-request.api'

export default ServiceRequestAPI
